import { Component } from '@angular/core';

@Component({
  selector: 'app-resources-online-courses',
  templateUrl: './resources-online-courses.component.html',
  styleUrls: ['./resources-online-courses.component.scss'],
})
export class ResourcesOnlineCoursesComponent {}
